import React, { useState, useEffect, useContext } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './HamburgerMenu.css';
import { AiFillCloseCircle } from 'react-icons/ai';
import { ImFolderDownload } from 'react-icons/im';
import ServiceReqForm from '../../images/newIcon/service request.svg'
import AccountStatement from '../../images/newIcon/Account Statement 1.svg'
import CapitalGain from '../../images/newIcon/Capital Gain Statement.svg'
import Application from '../../images/newIcon/Application form 1.svg'
import PanUpdation from '../../images/newIcon/pan updation.svg'
import NomineeReg from '../../images/newIcon/Nominee Registration 1.svg'
import fatcha from '../../images/newIcon/FATCA Registration 1.svg'
import adharpan from '../../images/newIcon/Link Your Aadhar with PAN 1.svg'
import OtmReg from '../../images/newIcon/OTM_eNACH Registration 1.svg'
import Contact from '../../images/newIcon/Contact Details Updation 1.svg'
// import close from '../../images/close.png'
import Close from '../../images/popup_close-btn.png'
import factsheet from '../../images/newIcon/Factsheet 1-1.svg';
import URLstateContext from "../../provider/CommonContext";
import {
    GetMethodData,
    DecryptAESdata, GetPostMethodData
} from "../../provider/ServiceProvider";
import { useRef } from "react";


// import Applicationform from '/CMS/downloads/Forms/Applicatoin Forms/JMF MF Common Application Form 040823.pdf'
// import ContactDetails from '../../image'
function HamburgerMenu({ closeNav }) {
    const [active, setactive] = useState();
    const [isActive, setIsActive] = useState(false);
    const { BaseURL, BaseURLShare } = useContext(URLstateContext);
    const [DataMisc, setDataMisc] = useState("");
    const [SubCategoryName, setSubCategoryName] = useState('Application Forms');
    // const handleClick = event => {
    //     // 👇️ toggle isActive state on click
    //     setIsActive(current => !current);
    // };

    const myFunction = () => {
        var element = document.getElementById("myDIV");
        element.classList.remove("side");
        //alert("remove")
    }

    const menuRef = useRef(null);

    const handleClick = () => {
  setIsActive(prev => !prev);
};

    useEffect(() => {
        GetPostMethodData(BaseURL + "Getmiscellaneous", {
            //   IISubCategoryID: subcatId,
            IVSubCategoryName: SubCategoryName,
        }).then((data) => {
            if (data.data != null && data.data.length > 0) {
                setDataMisc(DecryptAESdata(data.data));
                // console.log(DecryptAESdata(data.data),"Getmiscellaneous")
            }
        })
            .catch((error) => {
                //  console.log(error);
            });
    }, [SubCategoryName])

//  useEffect(() => {
//   if (isActive) {
//     menuRef.current?.focus();
//   }
// }, [isActive]);


useEffect(() => {
        if (isActive) {
            setTimeout(() => {
                const firstLink = menuRef.current?.querySelector('a[href]');
                if (firstLink) {
                    firstLink.focus();
                }
            }, 10);
        }
    }, [isActive]);


useEffect(() => {
    function handleClickOutside(event) {
        if (menuRef.current && !menuRef.current.contains(event.target)) {
            setIsActive(false);
        }
    }

    if (isActive) {
        document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
        document.removeEventListener('mousedown', handleClickOutside);
    };
}, [isActive]);

useEffect(() => {
        function handleEsc(e) {
            if (e.key === 'Escape' && isActive) {
                setIsActive(false);
            }
        }
        document.addEventListener('keydown', handleEsc);
        return () => document.removeEventListener('keydown', handleEsc);
    }, [isActive]);

    return (
        <>
            <div className="search-sc">
                <Container>
                    <Row>
                        <Col sm={12}>
                            {/* <div id="myDIV" className={isActive ? 'hamburger-main' : 'hamburger-main side'} onClick={handleClick}> */}

                            <div id="myDIV" className={`hamburger-main ${isActive ? "open" : ""}`} ref={menuRef} role='dialog' tabIndex="-1" aria-modal="true" aria-label="Services menu"> 

                                <div className='crossbtn' onClick={handleClick} >
                                    <button className="close-btn" aria-label='Close Services menu'>
                                        {/* <button onClick={myFunction}>X</button> */}
                                        <img src={Close} alt=""  onClick={myFunction} />
                                        {/* <img src={close} className="buttonclose" onClick={myFunction} /> */}
                                    </button>
                                </div>
                                <h2>Services</h2>
                                <div className='header-div'>
                                    <ul>
                                        <li><a href='/downloads/Forms' tabIndex={isActive ? 0 : -1}><img src={ServiceReqForm} className='icon-head' alt='service-req-form'/>Service Request Form</a></li>
                                        <li><a target='_blank' href=' https://investor.jmfinancialmf.com/jmfinvestor/' tabIndex={isActive ? 0 : -1}><img src={AccountStatement} className='icon-head' alt='account-statement'/>Account Statement</a></li>
                                        <li><a target='_blank' href='https://investor.jmfinancialmf.com/jmfinvestor/' tabIndex={isActive ? 0 : -1}><img src={CapitalGain} className='icon-head' alt='capital-gain'/>Capital Gain Statement</a></li>
                                        {/* <li><a className='cursorpointer'target='_blank'  href='/CMS/downloads/Forms/Application Forms/JMF MF Common Application Form 040823.pdf'><img src={Application} className='icon-head' />Application Form</a></li> */}
                                        <li>
                                            {DataMisc && DataMisc.map(({ FileName, SubCategoryName }) => (
                                                <a href={FileName} target="blank" tabIndex={isActive ? 0 : -1}>
                                                    <img src={Application} className='icon-head' alt='form'/>Application Form
                                                </a>
                                            ))}
                                        </li>
                                        <li><a href="downloads/Factsheet" tabIndex={isActive ? 0 : -1}><img src={factsheet} className='icon-head' alt='factsheet-icon' />Factsheet</a></li>
                                        <li><a target='_blank' href='https://mfs.kfintech.com/panupdation/' tabIndex={isActive ? 0 : -1}><img src={PanUpdation} className='icon-head' alt='' />PAN Updation</a></li>
                                        {/* <li><a href=''><ImFolderDownload className='icon-head'/>Register/Modify KYC Online</a></li> */}
                                        <li><a target='_blank' href='https://mfs.kfintech.com/investor/General/NCTNomineeUpdation' tabIndex={isActive ? 0 : -1}><img src={NomineeReg} className='icon-head' alt='' />Nominee Registration</a></li>
                                        <li><a target='_blank' href='https://mfs.kfintech.com/investor/Transact/ChangeFolioEmail' tabIndex={isActive ? 0 : -1}><img src={Contact} className='icon-head' alt='' />Contact Details Updation</a></li>
                                        <li><a target='_blank' href='https://investor.jmfinancialmf.com/jmfinvestor/' tabIndex={isActive ? 0 : -1}><img src={OtmReg} className='icon-head' alt='' />OTM/eNACH Registration</a></li>
                                        <li><a target='_blank' href='https://mfs.kfintech.com/mfs/fatca-kyc.aspx' tabIndex={isActive ? 0 : -1}><img src={fatcha} className='icon-head' alt='fatca-register' />FATCA Registration</a></li>
                                        <li><a target='_blank' href='https://rb.gy/tedfka' tabIndex={isActive ? 0 : -1}><img src={adharpan} className='icon-head' alt='adhaar-card-link' />Link Your Aadhar with PAN</a></li>
                                        {/* <li><a href='FinQ/FAQs'><ImFolderDownload className='icon-head' />FAQ's</a></li>
                                        <li><a href='/ReachOut'><ImFolderDownload className='icon-head' />Reach Out</a></li>
                                        <li><a href='/Aboutus/OurCororpate'><ImFolderDownload className='icon-head' />About Us</a></li> */}
                                    </ul>
                                    {/* <div className='btn-hamg'>
                                        <button className='btn-faq' aria-label='faqs butotn'><a href='/FAQs'>FAQ's</a></button>
                                        <button className='btn-reachout'aria-label='reach us button'><a href='/Reach-Us' aria-label='reach-us-button'>Reach Us</a></button>
                                    </div> */}
                                    <div className='btn-hamg'>
                                            <a href='/FAQs' className='btn-faq' aria-label="FAQs button" tabIndex={isActive ? 0 : -1}>
                                                FAQ's
                                            </a>

                                            <a href='/Reach-Us' className='btn-reachout' aria-label="Reach Us button" tabIndex={isActive ? 0 : -1}>
                                                Reach Us
                                            </a>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );

    //     return (
    //     <>
    //         <div id="overlay" onClick={() => closeNav(false)} className="search-sc">
    //             <Container>
    //                 <Row>
    //                     <Col sm={12}>
    //                         <div className={isActive ? '' : 'hamburger-main side'} onClick={handleClick}>
    //                             <div className='menu-pnl'>
    //                                 <ul>
    //                                     <li><a href=''>Investor</a></li>
    //                                     <li><a href=''>Partners</a></li>
    //                                     <li><a href=''>FinQ</a></li>
    //                                     <li><a className='cursorpointer' href='/Downloads'>Downloads</a></li>
    //                                     <li><a href=''>Reach Out</a></li>
    //                                 </ul>
    //                             </div>
    //                         </div>
    //                     </Col>
    //                 </Row>
    //             </Container>
    //         </div>
    //     </>
    // );
}

export default HamburgerMenu;


